module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/i18n/fr.json
// module id = fWCT
// module chunks = 37